import { useState, useEffect } from 'react';
import './Nav.css';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = ['about', 'projects', 'experience', 'contact'];

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav-logo">
        <span className="nav-logo-slash">~/</span>kelechi-onwuka
      </div>
      <div className="nav-links">
        {links.map(l => (
          <button key={l} className="nav-link" onClick={() => scrollTo(l)}>{l}</button>
        ))}
        <a
          href="/Kelechi_Onwuka_Resume_2026.pdf"
          className="nav-cta"
          target="_blank"
          rel="noreferrer"
        >
          résumé ↗
        </a>
      </div>
    </nav>
  );
}
